import React from 'react';
import './VideoBackground.css';

const VideoBackground = () => {
  return (
    <div className="video-background-container">
      <video
        className="video-background"
        src="/video/.mp4"
        autoPlay
        loop
        muted
        playsInline
      />
      <div className="video-overlay" />
    </div>
  );
};

export default VideoBackground;
